import React from "react";

import { Redirect, BrowserRouter as Router, Route, Switch } from "react-router-dom";

import ScrollToTop from "./ScrollToTop"

import Gallery from "./arcade/components/gallery/Gallery"
import Detail from "./arcade/components/detail/Detail"
import Console from "./arcade/components/console/Console"
import Manage from "./arcade/components/console/Manage"
import PlatformInvite from "./arcade/components/invite/PlatformInvite"
import DownloadLauncher from "./arcade/components/launcher/DownloadLauncher"
import DownloadEditor from "./arcade/components/editor_download/DownloadEditor"
import DownloadChangelog from "./arcade/components/editor_download/DownloadChangelog"

import SkipToLink from "./arcade/components/general/SkipToLink"
import Admin from "./arcade/platform/admin/index"
import NavBar from "./arcade/components/general/NavBar"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSpinner } from "@fortawesome/free-solid-svg-icons"

import "./App.css";

const User = React.createContext(0)

export class CheckLogin extends React.PureComponent {
    state = {
        loading: true,
        user: null,
    };
    componentDidMount() {
        fetch('/api/me').then(response => response.json())
            .then(result => {
                if (result.user) {
                    this.setState({ loading: false, user: result.user});
                    window.userToken = result.user.token
                } else {
                    this.setState({ loading: false });
                }
            });
    }
    render() {
        if (this.state.loading) {
            return (<div className="loadingWrapper">
                <h1 className="loading"><FontAwesomeIcon icon={faSpinner} spin /></h1>
            </div>);
        }
        if (!this.state.user) {
            const params = new URLSearchParams();
            params.set('url', window.location.pathname);
            return (<Redirect to={`/login?${params}`} />);
        }
        return (
            <User.Provider value={this.state.user}>
                <Router>
                    <SkipToLink />
                    <ScrollToTop />
                    <NavBar/>
                    <Switch>
                        <Route exact path="/"><Gallery /></Route>
                        <Route path="/arcade/game/:id"><Detail /></Route>
                        <Route path="/console/user/:id"><Console /></Route>
                        <Route path="/manage/game/:id"><Manage /></Route>
                        <Route path="/admin" render={p => <Admin {...p} user={this.state.user} />} />
                        <Route path="/invite"><PlatformInvite /></Route>
                        <Route path="/launcher"><DownloadLauncher /></Route>
                        <Route path="/editor_download"><DownloadEditor /></Route>
                        <Route path="/editor_changelog"><DownloadChangelog /></Route>
                    </Switch>
                </Router>
            </User.Provider>
        );
    }
}

export default CheckLogin
export { User }